import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Compatibility route that hands off legacy create/edit paths to the modal-first task manager flow.
 */
export const TaskFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const search = id ? `?taskModal=edit&taskId=${id}` : '?taskModal=create';
    navigate({ pathname: '/', search }, { replace: true });
  }, [id, navigate]);

  return <div className="loading">Opening task form...</div>;
};

export default TaskFormPage;
